<template>
  <FlexLayout role="region">
    <vue-loading :active="isLoading" :is-full-page="true" />

    <BlockContainer variant="full" :title="$t('studentAccounts.subTitle')">
      <Table
        small
        :items="children"
        :fields="fieldsWithActions"
        :responsive="true"
        :striped="true"
        :hover="true"
        :actions="tableActions"
        @charge="openModalTopUp"
        @transaction-history="showTransactionHistory"
        :show-empty="true"
      />
      <template #actions>
        <Button icon-left="plus" v-if="config.REGISTRATION_CHILD.enabled" @click="goToRegisterChild()"> {{ $t('studentAccounts.button.registerChild') }}</Button>
      </template>
    </BlockContainer>
  </FlexLayout>
</template>

<script>
import Utils from "@/utils/utils";
import VueLoading from "vue-loading-overlay";
import {accountService} from "@/services/api/accountService";
import Button from "@/components/actions/Button.vue";
import FlexLayout from "@/components/layout-components/Main/FlexLayout.vue";
import BlockContainer from "@/components/layout/BlockContainer.vue";
import Table from "@/components/data-display/Table.vue";

export default {
  components: {
    Table,
    BlockContainer,
    FlexLayout,
    Button,
    VueLoading
  },
  data() {
    return {
      isLoading: false,
      children: [],
    }
  },
  computed: {
    Utils() {
      return Utils
    },
    config() {
      return window.config;
    },
    fieldsWithActions() {
      return [
        { key: 'name', label: this.$t('studentAccounts.tableColumn.description'), sortable: true, tdClass: 'text-left', formatter: (value, key, item) => this.fullName(item) },
        { key: 'cardNum', label: this.$t('studentAccounts.tableColumn.cardNumber'), sortable: true, tdClass: 'text-left' },
        { key: 'formattedPrepaymentTotal', label: this.$t('studentAccounts.tableColumn.prepayBalanceCash'), sortable: true, class: 'text-right', formatter: (value, key, item) => this.Utils.formatCurrency(this.getPrepayBalance(item), this.config.ACCOUNT_BALANCE_CURRENCY), sortValue: (item) => (item.prepayBalanceCash + item.prepayBalanceVoucher + item.prepayBalanceBonus) },
        { key: 'actions', label: this.$t('studentAccounts.tableColumn.actions'), tdClass: 'text-right' }
      ];
    },
    tableActions() {
      return [
        {
          icon: ['fas', 'credit-card'],
          tooltip: this.$t('studentAccounts.tooltip.charge'),
          event: 'charge',
          show: () => true,
          class: 'order-details-button'
        },
        {
          icon: ['fas', 'clock-rotate-left'],
          tooltip: this.$t('studentAccounts.tooltip.transactionHistory'),
          event: 'transaction-history',
          show: () => true,
          class: 'cancel-order-button'
        }
      ];
    },
  },
  methods: {
    fullName(child) {
      const nameParts = [];

      if (child.description) {
        nameParts.push(child.description);
      }

      if (child.firstName) {
        nameParts.push(child.firstName);
      }

      return nameParts.join(' ').trim();
    },
    getPrepayBalance(child) {
      let separator = Utils.getDecimalSeparator(child.formattedPrepayBalanceCash);
      return (child.prepayBalanceCash + child.prepayBalanceVoucher + child.prepayBalanceBonus).toFixed(this.config.CUSTOMER_BALANCE_DECIMAL_PLACES).replace('.', separator);
    },
    async openModalTopUp(id) {
      this.$navigateToTopUp(true, id);
    },
    async showTransactionHistory(id) {
      this.$navigateToTransactionHistory(true, id);
    },
    async getStudentAccounts() {
      this.isLoading = true;
      const result = await accountService.afterLogin();
      this.isLoading = false;

      if (result.exception !== undefined || result.wondCustomer === undefined) {
        console.log(result.exception);
        return;
      }

      this.children = result.wondCustomer.children || [];
    },
    goToRegisterChild(){
      this.$navigateToRegisterChild();
    },
  },
  async created() {
    await this.getStudentAccounts();
  },
}
</script>
<style scoped>


.va-middle td{
  vertical-align: middle;
}
</style>
